import { RouteConfig } from 'vue-router';
import { ROUTE_NAME } from './constant';

export const routes: RouteConfig[] = [
    {
        path: '/user/match',
        name: ROUTE_NAME.MATCH,
        meta: {
            title: '我的赛事',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: 'user' */ './pages/match.vue'),
    },
    {
        path: '/user/finish_match',
        name: ROUTE_NAME.FINISH_MATCH,
        meta: {
            title: '我的完赛',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: 'user' */ './pages/finishMatch.vue'),
    },
    {
        path: '/user/finish_card/:activityId',
        name: ROUTE_NAME.FINISH_CARD,
        meta: {
            title: '完赛证书',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: 'user' */ './pages/finishCard.vue'),
    },
    {
        path: '/user/participation_certificates',
        name: ROUTE_NAME.PARTICIPATION_CERTIFICATES,
        meta: {
            title: '我的证书',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: 'user' */ './pages/participationCertificates.vue'),
    },
    {
        path: '/user/activity_certificates/:activityId',
        name: ROUTE_NAME.ACTIVITY_CERTIFICATES,
        meta: {
            title: '我的证书',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: 'user' */ './pages/activityCertificates.vue'),
    },
    {
        path: '/user/new_activity_certificates/:activityId',
        name: ROUTE_NAME.ACTIVITY_CERTIFICATES_NEW,
        meta: {
            title: '我的证书',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: 'user' */ './pages/newActivityCertificates.vue'),
    },
];
